import {ArticleFormStep, StepsMetadata} from "../contexts/article-form-context";
import {ArticleFormSchemaType} from "../constants/article-form-schema";

export const getStepSubtitle = (
    step: ArticleFormStep,
    formData: ArticleFormSchemaType,
    metadata: StepsMetadata,
    errors?: string[]
): string => {
    if (errors && errors.length > 0) {
        return errors[0];
    }

    const stepMetadata = metadata[step];

    switch (step) {
        case ArticleFormStep.CONTENT:
            if (stepMetadata.editedAt) {
                const date = new Date(stepMetadata.editedAt);
                const formattedDate = date.toLocaleDateString('pl-PL', {
                    day: '2-digit',
                    month: '2-digit',
                    year: '2-digit',
                });
                const formattedTime = date.toLocaleTimeString('pl-PL', {
                    hour: '2-digit',
                    minute: '2-digit',
                });
                return `Zmieniono ${formattedDate} - ${formattedTime}`;
            }
            return 'Nie zapisano';

        case ArticleFormStep.SPECIALIST: {
            const countSpecialists: number = formData.specialists?.length || 0;

            if (countSpecialists === 1) {
                return formData.specialists[0].fullName;
            }
            if (countSpecialists > 1) {
                return `${countSpecialists} wybrano`;
            }
            return 'Nie wybrano';
        }
        case ArticleFormStep.EXERCISES: {
            const countExercises: number = (formData as any).exercises?.length || 0;

            if (countExercises === 1) {
                return '1 wybrane ćwiczenie';
            }

            // polska odmiana: 2–4 „ćwiczenia”, 5+ „ćwiczeń”
            if (countExercises > 1) {
                const lastDigit = countExercises % 10;
                const lastTwoDigits = countExercises % 100;
                const isFew =
                    lastDigit >= 2 &&
                    lastDigit <= 4 &&
                    !(lastTwoDigits >= 12 && lastTwoDigits <= 14);

                if (isFew) {
                    return `${countExercises} wybrane ćwiczenia`;
                }
                return `${countExercises} wybranych ćwiczeń`;
            }

            return 'Nie wybrano';
        }
        case ArticleFormStep.RELATED: {
            const count = formData.relatedArticles?.length || 0;
            if (count > 0) {
                return `${count} ${count === 1 ? 'wybrano' : 'wybrane'}`;
            }
            return 'Nie wybrano';
        }

        case ArticleFormStep.AUTHOR:
            if (formData.authorName) {
                return formData.authorName;
            }
            return 'Nie wybrano';
        default:
            return 'Nie wybrano';
    }
};
